var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getKeys } from '../../adapters/utils';
import { SD_STATUS } from '../../consts';
import { getDataLegacy } from './get-data-legacy';
import { getData } from './get-data';
var IDs = {
    ID: 'group-post.id',
    INDEX_PAGE: 'page.index',
    POST_CONTENT: 'group-post.content',
    POST_CONTENT_60: 'group-post.content.60',
    POST_CONTENT_200: 'group-post.content.200',
    GROUP_NAME: 'group-post.name',
    PAGE_URL: 'group-post.url',
    POST_AUTHOR: 'group-post.createdBy.name',
    POST_PUBLISH_DATE: 'group-post.createdAt',
    POST_IMAGE_HEIGHT: 'group-post.image.height',
    POST_IMAGE_WIDTH: 'group-post.image.width',
    MAIN_IMAGE: 'group-post.image.url',
    SD_JSON_IMAGES: 'group-post.structured-data.images',
    DISABLE_IMAGES_SCHEMA: 'group-post.images-schema.disable',
};
var userVisible = [
    IDs.POST_CONTENT_60,
    IDs.POST_CONTENT_200,
    IDs.POST_AUTHOR,
    IDs.PAGE_URL,
    IDs.GROUP_NAME,
    IDs.POST_PUBLISH_DATE,
    IDs.MAIN_IMAGE,
];
var userVisibleSdOnly = [IDs.SD_JSON_IMAGES];
var requiredSchemaVariables = [];
var SchemaTypes = {
    GROUPS_POST: 'groups-post-preset',
    GROUP_POST_IMAGES: 'group-post-images',
};
var getSdStatus = function (item, data, schemaType) {
    if (schemaType === SchemaTypes.GROUP_POST_IMAGES &&
        data[IDs.SD_JSON_IMAGES] === '') {
        return SD_STATUS.DISABLED_DUE_TO_MISSING_INFO;
    }
    return SD_STATUS.ENABLED;
};
export default {
    IDs: IDs,
    requiredSchemaVariables: requiredSchemaVariables,
    SchemaTypes: SchemaTypes,
    getData: function (item) {
        var _a;
        var _b;
        var data = ((_b = item === null || item === void 0 ? void 0 : item.group) === null || _b === void 0 ? void 0 : _b.groupId)
            ? getDataLegacy(IDs, item)
            : getData(IDs, item);
        var imagesSdStatus = getSdStatus(item, data, SchemaTypes.GROUP_POST_IMAGES) !==
            SD_STATUS.ENABLED;
        return __assign(__assign({}, data), (_a = {}, _a[IDs.DISABLE_IMAGES_SCHEMA] = imagesSdStatus, _a));
    },
    getSdStatus: getSdStatus,
    getSlug: function () { return ''; },
    updateItemDataWithSlug: function (item) { return item; },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSdKeys: function () { return getKeys(IDs, userVisibleSdOnly); },
};
